import React, { useContext } from 'react';

import { SplitScreenContext } from './SplitScreen';
import Styled from './styles';

export interface PaneProps extends React.ComponentPropsWithRef<'div'> {
  children: React.ReactNode;
}

/** SplitScreen pane, all other props will be provided to the root DOM element */
const Pane = React.forwardRef<HTMLElement, PaneProps>((props: PaneProps, ref) => {
  const {
    children,
    ...otherProps
  } = props;
  const context = useContext(SplitScreenContext);
  return (
    <Styled.Pane isDragging={context.isDragging} ref={ref} {...otherProps}>
      {children}
    </Styled.Pane>
  );
});
Pane.displayName = 'Pane';
export default Pane;